import { useEffect, useState } from 'react';

import { CompatibilityBadge } from 'components/website/components/molecules/CompatibilityBadge/CompatibilityBadge';

import css from './FeatureHeroDecoration.module.css';

export type FeatureHeroDecorationProps = {
  videoComponent: (...props: any) => JSX.Element;
  compatibilities: React.ReactNode[];
};

export const FeatureHeroDecoration = ({
  videoComponent,
  compatibilities,
}: FeatureHeroDecorationProps) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);
  return (
    <div className={css.container}>
      {videoComponent(scrollPosition)}
      <CompatibilityBadge compatibilities={compatibilities} />
    </div>
  );
};
